import { render, staticRenderFns } from "./EditPW.vue?vue&type=template&id=7f8895d8&scoped=true&"
import script from "./EditPW.vue?vue&type=script&lang=js&"
export * from "./EditPW.vue?vue&type=script&lang=js&"
import style0 from "./EditPW.vue?vue&type=style&index=0&id=7f8895d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8895d8",
  null
  
)

export default component.exports